var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2248 7.23962L15.7872 1.45837C15.8989 1.33247 15.9704 1.17587 15.9926 1.00877C16.0148 0.841678 15.9866 0.671749 15.9117 0.520876C15.8443 0.364783 15.7326 0.232116 15.5905 0.139471C15.4483 0.0468266 15.2821 -0.00167817 15.1126 4.43345e-05H0.874575C0.706815 4.43345e-05 0.542516 0.0480803 0.400983 0.138486C0.25945 0.228891 0.146531 0.357907 0.0754795 0.51045C0.00402844 0.669188 -0.017366 0.846069 0.0141665 1.01736C0.0456991 1.18865 0.128665 1.34617 0.251913 1.46879L5.80394 7.25002V14.125C5.80645 14.2942 5.85777 14.459 5.95171 14.5996C6.04564 14.7401 6.17814 14.8502 6.33317 14.9167L6.53035 15H6.68604C6.89601 14.9968 7.0981 14.9193 7.25679 14.7813L9.9342 12.9184C10.0259 12.8379 10.0992 12.7385 10.1494 12.6271C10.1995 12.5157 10.2252 12.3948 10.2248 12.2725V7.23962ZM8.77191 12V7.23962C8.77191 6.86164 8.91812 6.49843 9.17971 6.22654L13.7674 1.45837H2.25989L6.84994 6.23791C7.11096 6.5097 7.2568 6.87251 7.2568 7.25002V12.9184L8.77191 12Z",
  fill: "#676879"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterIcon);
export default ForwardRef;